"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshRequest = exports.loginRequest = void 0;
const dex_guru_fetch_1 = require("@telekomconsalting/dex-guru-fetch");
const loginRequest = (instance, wallet, accountId, nonce, signature) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return yield dex_guru_fetch_1.apiFetch(instance, `/auth/login`, {
            init: {
                method: 'POST',
                body: JSON.stringify({
                    wallet,
                    nonce: nonce || '',
                    signature: signature || '',
                    account_id: accountId || '',
                }),
            },
            onError: (error) => {
                throw error;
            },
        });
    }
    catch (error) {
        console.log('login request error', error);
        throw error;
    }
});
exports.loginRequest = loginRequest;
const refreshRequest = (instance, refreshToken) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return yield dex_guru_fetch_1.apiFetch(instance, `/auth/refresh`, {
            init: {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${refreshToken}`,
                },
            },
            onError: (error) => {
                throw error;
            },
        });
    }
    catch (error) {
        console.log('refresh request error', error);
        throw error;
    }
});
exports.refreshRequest = refreshRequest;
//# sourceMappingURL=apiAuthAdapter.js.map